<template>
  <SettingsAnalyzerV2
    v-if="$store.getters.user_has_flag('HHV2')"
    :hasTitle="hasTitle"
  />
  <div
    v-else
    class="settings-analyzer"
  >
    <div
      v-if="hasTitle"
      class="theme-block-title"
    >
      {{ $t('settings.solutions_hh_anlyzer') }}
    </div>
    <div class="sa">
      <div
        v-for="(values, group, idx) in groups"
        :key="idx"
        class="sa_row position-relative f-align-center"
        :class="[
          { 'no-events clr-grey': values.soon },
          { 'no-events sa_row_no-options': values.single_option },
        ]"
      >
        <div class="sa_group f-align-center position-relative">
          {{ $t(`gametypes.groups.${group}`) }}
        </div>
        <span
          v-if="values.soon"
          class="info-tag info-tag_grey position-absolute"
          style="right: 8px"
        >
          {{ $t('common.soon') }}
        </span>
        <!-- TODO Vue3 fix offset -->
        <GwMenu placement="bottom">
          <template #opener="{ value }">
            <div
              class="sa_gametype position-relative"
              :class="[{ 'mt-1': !values.single_option }, { 'blurred no-events': loading }]"
            >
              <span class="pr-2 text-nowrap">
                {{
                  $t(`gametypes.${values.single_option ? '' : 'fullname.'}${getSelected(group).id}`)
                }}
              </span>

              <i
                v-if="!values.single_option"
                class="ml-auto transition_03 mdi-menu-down mdi mr-1"
                :class="{ rotated_180_before: value }"
              ></i>
            </div>
          </template>

          <div class="sa_gametypes gw_menu">
            <div
              v-for="item in values.types"
              :key="item.id"
              v-ripple
              class="sa_gametype-option f-align-center position-relative"
              :class="[
                { 'no-events clr-grey ': item.soon },
                { 'sa_gametype-option_selected': item.selected },
              ]"
              @click="selectType({ item, group, callApi: true })"
            >
              {{ $t(`gametypes.${values.single_option ? '' : 'fullname.'}${item.id}`) }}
              <span
                v-if="item.soon"
                class="info-tag info-tag_grey position-absolute"
                style="right: 12px; top: 2px"
              >
                {{ $t('common.soon') }}
              </span>
            </div>
          </div>
        </GwMenu>
      </div>
    </div>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import SettingsAnalyzerV2 from '@/components/Dialogs/UserSettingsDialog/SettingsAnalyzerV2'

export default {
  name: 'SettingsAnalyzer',
  components: {
    SettingsAnalyzerV2,
    GwMenu,
  },
  props: {
    hasTitle: { type: Boolean, default: true },
  },
  data() {
    return {
      loading: false,
      groups: {
        cash: {
          selected: true,
          public_id: '',
          api_id: 'Cash',

          types: [
            { id: 'Cash6m50zGeneral', api_id: 'Cash6m50zGeneral', selected: false },
            { id: 'Cash6m500zGeneral', api_id: 'Cash6m500zGeneral', selected: true },
            { id: 'Cash6m50zGeneral25Open', api_id: 'Cash6m50zGeneral25Open', selected: false },
            { id: 'Cash6m500zGeneral25Open', api_id: 'Cash6m500zGeneral25Open', selected: false },
            { id: 'Cash6m50zSimple', api_id: 'Cash6m50zSimple', selected: false },
            { id: 'Cash6m500zSimple', api_id: 'Cash6m500zSimple', selected: false },
            { id: 'Cash6m50zSimple25Open', api_id: 'Cash6m50zSimple25Open', selected: false },
            { id: 'Cash6m500zSimple25Open', api_id: 'Cash6m500zSimple25Open', selected: false },
            { id: 'Cash6m50zGGGeneral', api_id: 'Cash6m50zGGGeneral', selected: false },
            { id: 'Cash6m500zGGGeneral', api_id: 'Cash6m500zGGGeneral', selected: false },
            { id: 'Cash6m500zBasic', api_id: 'Cash6m500zBasic', selected: false },

            { id: 'Cash6m50zComplex', soon: true },
            { id: 'Cash6m500zComplex', soon: true },
            { id: 'Cash6m500zSimplified', soon: true },
            { id: 'Cash6m50zSimplified', soon: true },
          ],
        },
        spins: {
          single_option: true,
          types: [{ id: 'general', api_id: 'General', selected: true }],
        },
        husng: {
          single_option: true,
          types: [{ id: 'general', api_id: 'General', selected: true }],
        },
        mtt: {
          single_option: true,
          types: [{ id: 'general', api_id: 'General', selected: true }],
        },
        straddle_ante_cash: {
          single_option: true,
          types: [{ id: 'general', api_id: 'General', selected: true }],
        },
      },
    }
  },
  created() {
    this.getSettings()
  },
  methods: {
    async getSettings() {
      this.loading = true
      const result = await this.$store.dispatch('api_call', {
        endpoint: 'poker/preferred-format-types/',
        message: {
          type: 'error',
          status: 'error_fetching_preffered_gametype',
          statusMessages: {
            _error_fetching_preffered_gametype: {
              i18n: 'analyze.upload.error_fetching_preffered_gametype',
            },
          },
        },
      })
      this.loading = !!result.error
      const prefferedTypes = result.response?.data || []
      this.updateGroups(prefferedTypes)
    },
    async update({ item, group, public_id }) {
      const data = {
        // type: item.api_id,
        format: group.api_id,
        game_type_name: item.api_id,
      }
      const result = await this.$store.dispatch('api_call', {
        endpoint: `poker/preferred-format-types${public_id ? `/${public_id}/` : '/'}`,
        method: public_id ? 'PATCH' : 'POST',
        message: {
          type: 'error',
          status: 'error_updating_preffered_gametype',
          statusMessages: {
            _error_updating_preffered_gametype: {
              i18n: 'analyze.upload.error_updating_preffered_gametype',
            },
          },
        },
        data,
      })
      const prefferedType = result.response?.data || []
      // console.log(prefferedTypes)
      this.updateGroups([prefferedType])
    },
    updateGroups(prefferedTypes) {
      if (prefferedTypes[0]?.public_id) {
        prefferedTypes.forEach(i => {
          this.selectType({
            item: {
              id: i.game_type_name,
            },
            public_id: i.public_id,
            group: i.format.toLowerCase(),
          })
        })
      }
    },
    selectType({ item, group, public_id, callApi }) {
      this.groups[group].public_id = public_id || this.groups[group].public_id
      this.groups[group].types = this.groups[group].types.map(i => ({
        ...i,
        selected: item.id === i.id,
      }))
      // debugger
      if (callApi) {
        this.update({
          item,
          group: this.groups[group],
          public_id: this.groups[group].public_id,
        })
      }
    },
    getSelected(group) {
      const res = this.groups[group].types.find(i => i.selected)
      // console.log(res, this.groups[group].types)
      // debugger
      return res
    },
  },
}
</script>

<style lang="scss">
.settings-analyzer {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.sa {
  font-weight: 500;
  &_row {
    grid-gap: 1rem;
    display: flex;
    align-items: center;
    margin: 0 0 0.5rem 0;
    &:last-child {
      margin: 0;
    }
    // padding: 1rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &_no-options {
      .sa_gametype {
        box-shadow: none !important;
      }
    }
  }
  &_group {
    font-weight: 500;
    text-transform: uppercase;

    // border: solid red 1px;
    // min-width: 6.5rem;
  }
  &_gametypes {
    padding: 0.5rem 0;
  }
  &_gametype {
    cursor: pointer;
    display: flex;
    align-items: center;
    // flex: 1;
    border-radius: 4px;
    padding: 0 0 0 0.5rem;
    box-shadow: 0px 0px 0px 1px var(--clr-black-3);
    // color: var(--clr-grey-2);
    // &:hover {
    // }
  }
  &_gametype-option {
    font-weight: 500;

    padding: 0.5rem 1rem;
    cursor: pointer;
    &:hover {
      background: var(--clr-black-3);
    }
    &_selected {
      // background: var(--clr-black-3);
      color: var(--clr-primary);
    }
  }
}
</style>
